module.exports = __webpack_public_path__ + "img/chuangsai_04.caa83050.jpg";